import './App.css';
import LoginPage from "./pages/login-page/LoginPage";
import ResetRequestPage from "./pages/reset-request-page/ResetRequestPage";
import ResetPasswordPage from "./pages/reset-password-page/ResetPasswordPage";
import {Navigate, Route, Routes} from "react-router";
import ResetConfirmPage from "./pages/reset-confirm-page/ResetConfirmPage";
import ResetSuccessPage from "./pages/reset-success-page/ResetSuccessPage";

function App() {
    return (
        <Routes>
            <Route path="/">
                <Route path="/login" element={<LoginPage />} />
                <Route path="/request-reset" element={<ResetRequestPage />} />
                <Route path="/request-sent" element={<ResetSuccessPage />} />
                <Route path="/reset" element={<ResetPasswordPage />} />
                <Route path="/confirm-reset" element={<ResetConfirmPage />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
                <Route path="" element={<Navigate to="/login" replace />} />
            </Route>
        </Routes>
    );
}

export default App;
